export const MAP_STYLE_TEXT = {
    OS_EXPLORER: 'OS Explorer',
    OS_LANDRANGER: 'OS Landranger',
    OS_UK: 'OS_UK',
    NONE: 'NONE',
};
